import { Route, Routes } from 'react-router-dom';
import { NotFound, IncidentsQuery } from '@pages';
import { Protected } from '@components';

function RoutesIncidents() {
  return (
    <Protected>
      <Routes>
        <Route index element={<IncidentsQuery />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}

export default RoutesIncidents;
